/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDisclosure } from "@jumbo/components/JumboDialog/hooks/useDisclosure";
import DialogConfirm from "@jumbo/components/JumboDialog/components/DialogConfirm";

import Stack from "@mui/material/Stack";
import {
  Button,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { Card, CardContent } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import ClearIcon from "@mui/icons-material/Clear";
import Div from "@jumbo/shared/Div";
import Loader from "@jumbo/components/Loader";

import { usePagination } from "app/hooks/usePagination";
import { Table } from "app/components";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import { userType } from "app/helpers/userType";
import { useParams } from "react-router-dom";
import { deleteVariant, getVariantList } from "app/redux/slice/variantSlice";

const ProductVariant = () => {
  const { stageAction } = useDisclosure();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { isMA } = userType();
  let { productId } = useParams();

  const variantData = useSelector((state) => state?.variant);

  const [searchText, setSearchText] = useState("");
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("createdAt");

  const {
    isOpen: isDelete,
    onClose: closeDelete,
    actionProps: deleteActionProps,
    stageAction: deleteStageAction,
  } = useDisclosure();

  const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage } =
    usePagination({ id: "variant" });

  const [permissionData] = useState(
    JSON.parse(localStorage.getItem("permission"))
  );

  const [permission, setPermission] = useState({ deletePermission: false });
  const getPermission = () => {
    if (isMA) {
      setPermission({ deletePermission: true });
    } else {
      let permissionValue = { deletePermission: false };
      const rolePermission = permissionData;
      rolePermission?.length &&
        rolePermission.forEach(function (num) {
          if (num?.name === "delete-variant") {
            permissionValue.deletePermission = true;
          }
        });
      setPermission(permissionValue);
    }
  };

  const columns = [
    { id: "name", label: "Name", sort: true },
    { id: "variantCode", label: "Code", sort: true },
    { id: "colorId", label: "Color", render: (elm) => elm?.colorId?.name },
    { id: "sizeId", label: "Size", render: (elm) => elm?.sizeId?.name },
    { id: "baseCostPrice", label: "Base Cost Price" },
    { id: "baseSellingPrice", label: "Base Selling Price" },
    { id: "variantQuantity", label: "Quantity" },
    { id: "sampleQty", label: "Sample  Qty" },
    { id: "producibleQty", label: "Producible Qty", sort: true },
    {
      id: "actions",
      label: "Actions",
      minWidth: 100,
      align: "right",
      render: (row) => (
        <>
          <IconButton
            disabled={!permission.deletePermission}
            onClick={() => {
              deleteStageAction(row);
            }}
          >
            <DeleteIcon color={"error"} />
          </IconButton>
        </>
      ),
    },
  ];

  const DeleteProduct = () => {
    closeDelete();
    dispatch(deleteVariant(deleteActionProps?._id))
      .unwrap()
      .then((res) => {
        if (res?.status === 200) {
          enqueueSnackbar(res.data?.responseMessage, {
            variant: "success",
          });
          getData();
          closeDelete();
        } else {
          enqueueSnackbar(res.data?.responseMessage, {
            variant: "error",
          });
        }
      });
  };

  const getData = () => {
    localStorage.setItem("variant-search", searchText.trim());
    const value = {
      page: page,
      perPage: rowsPerPage,
      search: searchText.trim(),
      productId,
    };
    if (orderBy !== "") {
      value.sort = order === "asc" ? 1 : -1;
      value.field = orderBy;
    }
    dispatch(getVariantList(value));
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleChangePage(0, 0);
      getData();
    }
  };

  const sortData = (Order, OrderBy) => {
    setOrder(Order);
    setOrderBy(OrderBy);
  };

  useEffect(() => {
    getPermission();
  }, []);

  useEffect(() => {
    getData();
  }, [page, rowsPerPage, dispatch, order, orderBy]);

  return (
    <>
      {variantData?.loading ? (
        <Loader />
      ) : (
        <>
          <Card sx={{ display: "flex", mb: 3 }}>
            <Div sx={{ display: "flex", flexDirection: "column", flex: "1" }}>
              <CardContent>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={10}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Search"
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      onKeyPress={handleKeyPress}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment
                            position="end"
                            style={{
                              display: searchText === "" ? "none" : "flex",
                            }}
                            onClick={() => setSearchText("")}
                          >
                            <ClearIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <Button
                      fullWidth
                      type="submit"
                      variant="contained"
                      onClick={() => {
                        handleChangePage(0, 0);
                        getData();
                      }}
                    >
                      Submit
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Div>
          </Card>
          <Card>
            <CardContent>
              <Stack
                justifyContent="space-between"
                direction={{ xs: "column", sm: "row" }}
                sx={{ mb: 3 }}
              >
                <Typography variant={"h2"} mb={0}>
                  Product Variant List
                </Typography>
              </Stack>
              <Table
                columns={columns}
                rows={variantData?.list}
                page={page}
                rowsPerPage={rowsPerPage}
                Order={order}
                count={variantData?.total}
                OrderBy={orderBy}
                sortData={sortData}
                handleChangePage={handleChangePage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                editAction={stageAction}
              />
            </CardContent>
          </Card>
          <DialogConfirm
            isOpen={isDelete}
            onClose={closeDelete}
            title="Are you sure you want to delete the product?"
            onConfirm={DeleteProduct}
            btnLabels={{ cancel: "Cancel", confirm: "Delete" }}
          />
        </>
      )}
    </>
  );
};

export default ProductVariant;
